<ion-header
  class="ion-no-border"
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-header-modal-desktop'
      : platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button
        *ngIf="platform === platformRef.desktop"
        id="close-modal-btn"
        data-cy="close-copy-products-modal-icon"
        (click)="dismissModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label [attr.data-cy]="'copy-to-groups-title'" class="title-bold">
      {{ title | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  scrollY="false"
  [ngClass]="
    platform === platformRef.desktop
      ? 'ion-content-modal-desktop'
      : platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
  "
>
  <ion-grid>
    <ion-row class="item-row">
      <ion-col class="left-column">
        <ion-item class="column-title">
          {{
            'i18n.lists.copyProductsModal.copyProductsViewSelected' | translate
          }}
        </ion-item>
        <div class="scroll-container" cdkVirtualScrollingElement>
          <ion-item *ngFor="let product of selectedProducts" class="list-item">
            <div class="item-container">
              <div class="image-column">
                <ion-img
                  *ngIf="product?.imageThumbnail"
                  [src]="product?.imageThumbnail"
                ></ion-img>
                <ion-icon
                  *ngIf="!product?.imageThumbnail"
                  data-cy="product-card-no-image-icon"
                  class="no-image"
                  name="restaurant"
                ></ion-icon>
              </div>
              <div class="summary-column">
                <div class="product-info">
                  <div>
                    {{
                      product.summary.brand
                        | titlecase
                        | truncateWithEllipsis: 30
                    }}
                  </div>
                  <img
                    class="product-card-separator"
                    data-cy="product-card-separator-image"
                    src="assets/images/separator.png"
                  />
                  <div>#{{ product.summary.productNumber }}</div>
                  <img
                    class="product-card-separator"
                    data-cy="product-card-separator-image"
                    src="assets/images/separator.png"
                  />
                  <div>
                    {{ product.summary.salesPackSize }}
                  </div>
                </div>
                <div class="product-description">
                  {{
                    product.summary.productDescTxtl
                      | titlecase
                      | truncateWithEllipsis: 40
                  }}
                </div>
              </div>
            </div>
          </ion-item>
        </div>
      </ion-col>
      <ion-col>
        <ion-item class="column-title">
          {{ 'i18n.lists.copyProductsModal.copyProductsTarget' | translate }}
        </ion-item>
        <ion-radio-group [(ngModel)]="selection">
          <ion-item [ngClass]="groups.length === 1 ? 'radio-disabled' : ''">
            <ion-radio
              mode="md"
              [disabled]="groups.length === 1"
              [value]="'group'"
            >
              <div>
                {{ 'i18n.lists.copyProductsModal.differentGroup' | translate }}
              </div>
            </ion-radio>
          </ion-item>
          <ion-item
            *ngIf="!hideCopyToListOption"
            [ngClass]="!enableCopyToList ? 'radio-disabled' : ''"
          >
            <ion-radio
              mode="md"
              [value]="'list'"
              [disabled]="!enableCopyToList"
            >
              <div>
                {{ 'i18n.lists.copyProductsModal.differentList' | translate }}
              </div>
            </ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        [attr.data-cy]="'copy-list-cancel-button'"
        [ngClass]="
          platform === platformRef.mobile
            ? 'usf-outline-green-mobile-modal-button'
            : 'usf-outline-green-dsktp-tblt-modal-button'
        "
        (click)="dismissModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>

      <ion-button
        [attr.data-cy]="'copy-list-next-button'"
        [ngClass]="
          !selection
            ? platform === platformRef.mobile
              ? 'usf-fill-disabled-mobile-modal-button'
              : 'usf-fill-disabled-dsktp-tblt-modal-button'
            : platform === platformRef.mobile
              ? 'usf-fill-green-mobile-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
        "
        (click)="next()"
      >
        {{ 'i18n.common.next' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
